export default "__VITE_ASSET__DbHRHEeM__"